<template>
  <div>
    <div class="app-content">
      <div>
        <navbar/>
            <modal-register></modal-register>
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
            <btn v-if="currentRouteName != 'landingRegister' && currentRouteName != 'landingQuickRegister'"></btn>
            <whatsAppButton></whatsAppButton>
         <footerLanding />
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/navbar.vue";
import footerLanding from "../components/footerLanding.vue";
import whatsAppButton from "@/components/whatsAppButton";
import ModalRegister from "@/components/modalRegister";
import btn from "../components/btnUpdateData.vue";

export default {
  data(){
    return{
      currentRouteName: "",
    };
  },
  components: {
    ModalRegister,
    navbar: navbar,
    footerLanding: footerLanding,
    btn,
    whatsAppButton: whatsAppButton,
  },
  mounted() {
    // Inicializar el nombre de la ruta actual
    this.currentRouteName = this.$route.name;

    // Escuchar cambios en el route.name utilizando un watcher
    this.$watch('$route', (to, from) => {
      if (to.name !== from.name) {
        this.currentRouteName = to.name;
      }
    });
  }
};
</script>
